import { render, staticRenderFns } from "./RouteCoverage.vue?vue&type=template&id=4bc9ec32&scoped=true&"
import script from "./RouteCoverage.vue?vue&type=script&lang=js&"
export * from "./RouteCoverage.vue?vue&type=script&lang=js&"
import style0 from "./RouteCoverage.vue?vue&type=style&index=0&id=4bc9ec32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc9ec32",
  null
  
)

export default component.exports